import React, { useEffect } from 'react'
import { useNavigate } from 'react-router'
import { ROUTES } from '../resources/routes-constants'
import { useNavigationTranslations } from '../hooks/useNavigationTranslations';
import RobotsNoIndex from 'src/components/seo/RobotsNoIndex';

interface NotFoundPageProps {
    locale?: string;
}

const NotFoundPage: React.FC<NotFoundPageProps> = ({ locale: propLocale }) => {
    const navigate = useNavigate()
    const { translations: t, language, changeLanguage } = useNavigationTranslations();

    useEffect(() => {
        if (propLocale && propLocale !== language) {
            changeLanguage(propLocale);
        }
    }, [propLocale, language, changeLanguage]);

    const redirectToHomePage = () => {
        navigate(ROUTES.HOMEPAGE_ROUTE)
    }

    return (
        <>
            <RobotsNoIndex />
            <div style={{ 
                position: 'relative', 
                width: '100%', 
                display: 'flex', 
                justifyContent: 'center', 
                alignItems: 'center', 
                flexDirection: 'column', 
                gap: '1rem', 
                minHeight: '60vh' 
            }}>
                <h1 style={{ fontSize: '4em' }}>{t.navigations.notFound.title}</h1>
                <h2 style={{ fontSize: '2em', color: '#666' }}>{t.navigations.notFound.subtitle}</h2>
                <button
                    onClick={redirectToHomePage}
                    style={{
                        padding: '0.75rem 1.5rem',
                        fontSize: '1.25rem',
                        cursor: 'pointer',
                        borderRadius: '5px',
                        border: 'none',
                        backgroundColor: '#007bff',
                        color: 'white',
                        transition: 'background-color 0.3s',
                    }}
                    onMouseEnter={e => (e.currentTarget.style.backgroundColor = '#0056b3')}
                    onMouseLeave={e => (e.currentTarget.style.backgroundColor = '#007bff')}
                >
                    {t.navigations.notFound.homeLink}
                </button>
            </div>
        </>
    )
}

export default NotFoundPage;
